import React from 'react';
import ListItemLink from './ListItemLink';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { LinkTheme } from './LinkTheme';

export default function Link(props) {
  
  return (
    <ThemeProvider theme={LinkTheme}>
      {!!(props.href)?<ListItemLink val={props.href} label={props.label}/>:null}
    </ThemeProvider>
  )
}
